<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="子账号详情"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off" disabled>
            <el-form-item label="子账号姓名" prop="user_name">
                <el-input type="text" v-model="ruleForm.user_name" placeholder="请输入子账号姓名" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="登录手机号码" prop="mobile">
                <el-input type="text" v-model="ruleForm.mobile" placeholder="请输入登录手机号码" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="关联健康管理对象" prop="client_id">
                <el-select v-model="ruleForm.client_id" placeholder="请选择关联健康管理对象" style="width: 100%;">
                    <el-option
                            v-for="item in allClientUSer"
                            :key="item.user_id"
                            :label="item.user_name"
                            :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="头像">
                <el-input type="hidden" v-model="ruleForm.user_avatar" placeholder="头像"
                          style="width: 100%;"></el-input>
                <el-upload
                        class="avatar-uploader"
                        :action="upload_path"
                        :show-file-list="false"
                        :on-success="handleUserAvatarImgSuccess"
                        :before-upload="beforeAvatarUpload">
                    <img style=" width: 316px;height: 200px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                         class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div>请上传jpg/png格式的图片</div>
            </el-form-item>

        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";

    export default {
        created() {

            this.user_id = this.$route.query.user_id || this.$route.params.user_id;
            
        },

        mounted() {
            this.createParams();
        },
        data() {
            return {
                user_id: '',
                upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
                userAvaratImageUrl: '',
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                allClientUSer: [],
                ruleForm: {
                    user_name: "",
                    mobile: "",
                    client_id: "",
                    status: 1,
                    user_avatar: "",
                },
                rules: {
                    user_name: [
                        {required: true, message: "请输入健康管理对象姓名", trigger: "blur"},
                    ],
                    mobile: [
                        {required: true, message: "请输入手机号码", trigger: "blur"},
                    ],
                    client_id: [
                        {required: true, message: "请选择关联健康管理对象", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],

                },
                is_submit: false,
            };
        },
        methods: {
            // 子账号详情
            createParams() {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'userAssistantDetail',
                    params: {
                         user_id:this.user_id,
                    }

                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    this.ruleForm.user_name = res.data.data.user_name;
                    this.ruleForm.mobile = res.data.data.client_user_mobile;
                    this.ruleForm.client_id = res.data.data.client_user_name;
                    this.ruleForm.status = res.data.data.status-0;
                    if(res.data.data.user_avatar)
                    {
                        this.userAvaratImageUrl  = this.imgUrl + res.data.data.user_avatar;
                    }
                    
                });
            },

            // 返回上一页
            goBack() {

                if (this.$route.query.user_id) {
                    window.close()
                } else {
                    window.history.go(-1);
                }
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminCustomerServices',
                            'method': 'editUserAssistant',
                            'params': {
                                user_id:this.user_id,
                                client_id: this.ruleForm.client_id,
                                user_name: this.ruleForm.user_name,
                                mobile: this.ruleForm.mobile,
                                status: this.ruleForm.status,
                                user_avatar: this.ruleForm.user_avatar,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                                duration: 1500,
                                onClose: function () {
                                    window.history.go(-1);
                                }
                            });
                            this.is_submit = false;
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
            },

            // 上传身份证正面图片
            handleUserAvatarImgSuccess(res) {
                if (res.code == 0) {
                    this.ruleForm.user_avatar = res.data;
                    this.userAvaratImageUrl = this.imgUrl + res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            },

            //上传图片之前，检测文件格式
            beforeAvatarUpload(file) {
                if (file.type === 'image/jpeg' || file.type === 'image/png') {
                    var isJPG = true;
                } else {
                    var isJPG = false;
                }
                // const isLt2M = file.size / 1024 < 200;
                if (!isJPG) {
                    this.$message.error('图片只能是jpg/png格式!');
                }
                // if (!isLt2M) {
                //     this.$message.error('图片大小不能超过200KB!');
                // }
                return isJPG;
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
